import { Emitter } from '@epihub/core/src/events';
import { type NavigateOptions, type To } from './navigate';

export const navigationEventEmitter = new Emitter();

export const navigateEvent = Emitter.event<{
  to: To;
  options?: NavigateOptions;
}>('navigationEventEmitter-navigateEvent')((data) => ({}));
